import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { ReinforcedControlMeasureCreation, ReinforcedControlMeasureValidation, resetReinforcedControlMeasureValidation, setReinforcedCreationCustomerDataId } from "../slice"
import { ReinforcedControlMeasureForm } from "./forms"

export function AddReinforcedControlMeasure() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const reinforcedControlMeasureState = useAppSelector(state => state.reinforcedControlMeasure)

    useEffect(() => {
        dispatch(setReinforcedCreationCustomerDataId(sessionState.selected.customerId))
    }, [])

    useEffect(() => {
        if (reinforcedControlMeasureState.reinforcedControlMeasureValidationStatus === 'successfully') {
            dispatch(resetReinforcedControlMeasureValidation())
            dispatch(ReinforcedControlMeasureCreation(reinforcedControlMeasureState.reinforcedControlMeasuresCreationRequest))
        }
    }, [reinforcedControlMeasureState.reinforcedControlMeasureValidationStatus])

    useEffect(() => {
        if (reinforcedControlMeasureState.reinforcedControlMeasureCreationStatus === 'successfully') {
            navigate('/reinforcedControlMeasure')
        }
    }, [reinforcedControlMeasureState.reinforcedControlMeasureCreationStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Gestione Provvedimenti', 'Inserimento Misura di Controllo Rinforzato']}
            noPaddingLat
            headerLabel="Misura di Controllo Rinforzato"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/reinforcedControlMeasure')} color={colors.white} />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Salva"
                        color={"orange"}
                        onClick={() => dispatch(ReinforcedControlMeasureValidation(reinforcedControlMeasureState.reinforcedControlMeasuresCreationRequest))}
                    />
                </div>
            }
        >
            <ReinforcedControlMeasureForm />
        </Layout>
    )
}